<template>
  <!-- The same bar on every page (SPEC §4.3): signed in, the game list, a new game, the settings and the account;
       signed out, the logo only. The current page's item is marked. -->
  <nav class="navbar" :class="{ mobile: $store.state.isMobile }">
    <router-link :to="user ? { name: 'list' } : { name: 'root' }" class="brand">
      <img :src="logo" :alt="t('app-name')">
    </router-link>
    <template v-if="user">
      <router-link :to="{ name: 'list' }" class="item" :class="{ current: current === 'list' }"
                   :aria-current="current === 'list' ? 'page' : null">{{ t('nav-list') }}</router-link>
      <router-link :to="{ name: 'create-game' }" class="new" :class="{ current: current === 'create-game' }"
                   :aria-current="current === 'create-game' ? 'page' : null">{{ t('nav-new') }}</router-link>
      <span class="space"></span>
      <router-link :to="{ name: 'settings' }" class="item" :class="{ current: current === 'settings' }"
                   :aria-current="current === 'settings' ? 'page' : null">{{ t('nav-settings') }}</router-link>
      <router-link :to="{ name: 'account' }" class="item name" :class="{ current: current === 'account' }"
                   :aria-current="current === 'account' ? 'page' : null">{{ user.displayName }}</router-link>
    </template>
  </nav>
</template>

<script>
import imgLogo from '@/assets/slowgo-sm.png';
import { t } from '@/texts';

export default {
  name: 'NavBar',

  data() {
    return { logo: imgLogo };
  },

  computed: {
    user() {
      return this.$store.state.user;
    },

    // The bar item of the page shown, if any.
    current() {
      const name = this.$route.name;
      return ['list', 'create-game', 'settings', 'account'].includes(name) ? name : null;
    },
  },

  methods: { t },
}
</script>

<style scoped>
.navbar {
  display: flex;
  align-items: center;
  background: #faedcd;
  padding: 5px 16px 5px 10px;
  font-size: 16px;
}

/* On a phone the bar is 44 px high, to leave the board room. */
.navbar.mobile {
  padding: 6px 10px 6px 8px;
}

.brand {
  display: flex;
  margin-right: 16px;
}

.brand img {
  height: 50px;
}

.mobile .brand {
  margin-right: 12px;
}

.mobile .brand img {
  height: 32px;
}

/* Starting a game is drawn as a small outlined button, so it doesn't get lost among the links. */
.new {
  margin-left: 14px;
  padding: 3px 8px;
  border: 1px solid #c9a96a;
  border-radius: 6px;
  background: #fff8e6;
  color: #2c3e50;
  text-decoration: none;
  white-space: nowrap;
}

.new.current {
  font-weight: bold;
}

.space {
  flex: 1;
}

.item {
  color: #595959;
  text-decoration: none;
  white-space: nowrap;
  padding: 6px 0;
  margin-left: 18px;
}

.item:first-of-type {
  margin-left: 0;
}

.item:hover {
  color: #0175ff;
}

.item.current {
  color: #2c3e50;
  font-weight: bold;
  text-decoration: underline;
  text-underline-offset: 4px;
}

/* A long display name is cut short; everything else keeps its place. */
.item.name {
  max-width: 8em;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile .item.name {
  max-width: 6em;
}
</style>
